var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgProvision({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.80833 2.16667L13.8333 6.19167V13.8333H2.16667V2.16667H9.80833ZM9.80833 0.5H2.16667C1.25 0.5 0.5 1.25 0.5 2.16667V13.8333C0.5 14.75 1.25 15.5 2.16667 15.5H13.8333C14.75 15.5 15.5 14.75 15.5 13.8333V6.19167C15.5 5.75 15.325 5.325 15.0083 5.01667L10.9833 0.991667C10.675 0.675 10.25 0.5 9.80833 0.5ZM3.83333 10.5H12.1667V12.1667H3.83333V10.5ZM3.83333 7.16667H12.1667V8.83333H3.83333V7.16667ZM3.83333 3.83333H9.66667V5.5H3.83333V3.83333Z",
    fill: "#4A4A4A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProvision);
export default __webpack_public_path__ + "static/media/provision.985899be8f7ed3e3cb35b272a9b91dc2.svg";
export { ForwardRef as ReactComponent };